class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  onChange(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    const id = event.target.dataset.id;
    this.updateQuantity(index, inputValue, id);
  }

  updateQuantity(line, quantity, id) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach((section) => {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
          if (section.id == 'cart-notification-upsell') {
            this.renderRecommendations(id);
          }
        });
      })
      .catch(() => {
      })
      .finally(() => {
      });
        
  }
  
  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderRecommendations(id) {
    var cartNotificationRecommendationsSection = document.querySelector(".cart-notification-collection");
    if (cartNotificationRecommendationsSection) {
  
    var url = cartNotificationRecommendationsSection.dataset.url;
    var productId = id;
    var sectionId = cartNotificationRecommendationsSection.dataset.sectionId;
  
    fetch(`${url}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-notification-collection');
  
        if (recommendations?.innerHTML.trim().length) {
          cartNotificationRecommendationsSection.innerHTML = recommendations.innerHTML;

          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          var cart_notification_slider = new Swiper('#cart-notification .cart-notification-collection_wrap', {
            slidesPerView: 2.3,
            spaceBetween: 20,
            freeMode: true,
            mousewheel:{
              forceToAxis: true
            },
            breakpoints: {
              750: {
                  slidesPerView: 3.5
              },
              990: {
                  slidesPerView: 4.5
              }
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
    }
  }
  
  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
      if (section.id == 'cart-notification-upsell') {
        this.renderRecommendations(parsedState.product_id);
      }
    });
    
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-notification-upsell',
      },
      {
        id: 'cart-notification-freeshipping',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);